import { z } from 'zod'

const optionalJsonObjectSchema = z.string().refine((val) => {
  if (!val) return true
  try {
    const parsed = JSON.parse(val)
    return typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)
  } catch {
    return false
  }
}, 'Must be valid JSON, e.g. {"key": "value"}')

export const DormakabaConnectionSchema = z.object({
  clientId: z.string().min(1, 'Client ID is required'),
  clientSecret: z.string().min(1, 'Client Secret is required'),
  config: optionalJsonObjectSchema,
  host: z.string().min(1, 'Host is required'),
  password: z.string().min(1, 'Password is required'),
  protocol: z.string().min(1, 'Protocol is required'),
  requesterId: z.string().min(1, 'Requester ID is required'),
  scope: z.string().min(1, 'Scope is required'),
  tokenHost: z.string().min(1, 'Token Host is required'),
  tokenProtocol: z.string().min(1, 'Token Protocol is required'),
  username: z.string().min(1, 'Username is required'),
})

export type DormakabaConnectionFormValues = z.infer<typeof DormakabaConnectionSchema>

export const dormakabaDefaultValues: DormakabaConnectionFormValues = {
  clientId: '',
  clientSecret: '',
  config: '',
  host: '',
  password: '',
  protocol: 'https',
  requesterId: 'WS1',
  scope: '',
  tokenHost: '',
  tokenProtocol: 'https',
  username: '',
}
